import type { ComponentType } from "preact";

type Island = () => Promise<{ default: ComponentType<Record<string, unknown>> }>;

// Each island is its own chunk, fetched when a page first mounts it.
export const islands: Record<string, Island> = {
	admin_search: () => import("./admin_search"),
	admin_traffic: () => import("./admin_traffic"),
	campaign_hub: () => import("./campaign_hub"),
	character_sheet: () => import("./character_sheet"),
	encounter: () => import("./encounter"),
	hello: () => import("./hello_island"),
	map_combat: () => import("./map_combat"),
	map_notes: () => import("./map_notes"),
	map_rolls: () => import("./map_rolls"),
	map_sound: () => import("./map_sound"),
	map_sound_chip: () => import("./map_sound_chip"),
	map_sound_prompt: () => import("./map_sound_chip").then((chip) => ({ default: chip.SoundPrompt })),
	map_token_pv: () => import("./map_token_pv"),
	ui_kit: () => import("./ui_kit"),
	workshop: () => import("./workshop"),
};
